import Cookies from "js-cookie";
import { format } from "date-fns";

/**
 * Created by PanJiaChen on 16/11/18.
 */

/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string | null}
 */
export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null;
  }
  const format = cFormat || "{y}-{m}-{d} {h}:{i}:{s}";
  let date;
  if (typeof time === "object") {
    date = time;
  } else {
    if (typeof time === "string" && /^[0-9]+$/.test(time)) {
      time = parseInt(time);
    }
    if (typeof time === "number" && time.toString().length === 10) {
      time = time * 1000;
    }
    date = new Date(time);
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay(),
  };
  const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
    const value = formatObj[key];
    // Note: getDay() returns 0 on Sunday
    if (key === "a") {
      return ["日", "一", "二", "三", "四", "五", "六"][value];
    }
    return value.toString().padStart(2, "0");
  });
  return time_str;
}

/**
 * @param {number} time
 * @param {string} option
 * @returns {string}
 */
export function formatTime(time, option) {
  if (("" + time).length === 10) {
    time = parseInt(time) * 1000;
  } else {
    time = +time;
  }
  const d = new Date(time);
  const now = Date.now();

  const diff = (now - d) / 1000;

  if (diff < 30) {
    return "刚刚";
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + "分钟前";
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + "小时前";
  } else if (diff < 3600 * 24 * 2) {
    return "1天前";
  }
  if (option) {
    return parseTime(time, option);
  } else {
    return (
      d.getMonth() +
      1 +
      "月" +
      d.getDate() +
      "日" +
      d.getHours() +
      "时" +
      d.getMinutes() +
      "分"
    );
  }
}

/**
 * @param {string} url
 * @returns {Object}
 */
export function param2Obj(url) {
  const search = url.split("?")[1];
  if (!search) {
    return {};
  }
  return JSON.parse(
    '{"' +
      decodeURIComponent(search)
        .replace(/"/g, '\\"')
        .replace(/&/g, '","')
        .replace(/=/g, '":"')
        .replace(/\+/g, " ") +
      '"}'
  );
}

/**
 * @param {Object} vue
 * @param {Object} newQuery
 */
export function updateQuery(vue, newQuery) {
  const { query = {} } = vue.$route;
  const copyQuery = Object.assign({}, query);

  vue.$router.push({ query: Object.assign(copyQuery, newQuery) });
}

export function addTaskToLocalStorage(token) {
  const segmentsIdentifiers = Cookies.get("segmentsIdentifiers")
    ? JSON.parse(Cookies.get("segmentsIdentifiers"))
    : [];
  const days = 1;

  segmentsIdentifiers.push(token);

  Cookies.set("segmentsIdentifiers", JSON.stringify(segmentsIdentifiers), {
    expires: days,
  });
}

/**
 * @param {String} url
 * @returns {Boolean}
 */
export const isValidUrl = (url) => {
  var pattern = new RegExp(
    "^(https?:\\/\\/)?" + // protocol
      "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name
      "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
      "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
      "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
      "(\\#[-a-z\\d_]*)?$",
    "i"
  ); // fragment locator
  return !!pattern.test(url);
};

/**
 * Возвращаем дату без таймзоны
 * @param {String} strDate дата RFC3339
 * @returns Date
 */
export function formatDateWithoutTimezone(strDate) {
  if (typeof strDate === "string") {
    // используем только часть date-time https://datatracker.ietf.org/doc/html/rfc3339#section-5.6 без time-offset
    // т.к. на беке не целостностные даты
    const dateWithoutTimezone = strDate.slice(0, 19); // yyyy-MM-dd HH:mm:ss

    return new Date(dateWithoutTimezone);
  }
  return strDate;
}

export function formatDateToRFC3339WithoutTimezone(date) {
  if (date) {
    const dateFormatted = format(new Date(date), "yyyy-MM-dd HH:mm:ss");

    return dateFormatted.replace(" ", "T");
  }
  return date;
}

export function formatDate(date) {
  if (date) {
    return format(new Date(date), "yyyy-MM-dd");
  }
  return date;
}
